import * as React from 'react';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import * as uuid from 'uuid/v4';
import { withRouter } from 'react-router-dom';
import { compose, withHandlers, onlyUpdateForKeys, withProps } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { RepairsCreateFormBasic } from '@modules/repairs/RepairsCreateFormBasic';
import { Tabs } from '@components/tabs';
import * as T from '@modules/repairs/_repairsTypes';
import { RepairType } from '@modules/repairs/_repairsEnums';
import { RepairsInvoicesForm } from '@modules/repairs/RepairsInvoicesForm';
import { putRepair } from '@modules/repairs/_repairsActions';
import { getActualDate } from '@utils/utils';

export const closeForm = '/repairs';

export const enhance = compose<any, T.RepairCreateProps>(
  withRouter,
  onlyUpdateForKeys(['url', 'location']),
  withHandlers({
    closeItem:
      ({ history }) =>
      async () => {
        history.push(closeForm);
      }
  }),
  withHandlers({
    onSubmit:
      ({ repairType, closeItem }) =>
      async data => {
        const body = { id: uuid(), type: repairType, ...data };
        const result = await putRepair(body);
        if (result) {
          await closeItem();
        }
      }
  }),
  withProps<{}, any>(({ initialValues, repairType }) => ({
    initialValues: {
      invoices: [],
      repairTime: repairType === RepairType.MAINTENANCE ? getActualDate() : '',
      ...initialValues // for testing purposes
    }
  })),
  breadcrumbs(({ repairType }) => [{ label: 'Opravy', to: '/repairs' }, { label: repairType.label }]),
  reduxForm({ form: 'create-repair' })
);

export const View: React.SFC<any> = ({ handleSubmit, repairType, change, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        {repairType === RepairType.REPAIR ? (
          <Tabs
            items={[
              {
                label: 'Vytvoření',
                style: { minWidth: 175 },
                content: <RepairsCreateFormBasic change={change} type={repairType} formName="create-repair" />
              },
              { label: 'Faktury', style: { minWidth: 175 }, content: <RepairsInvoicesForm /> }
            ]}
          />
        ) : (
          <RepairsCreateFormBasic change={change} type={repairType} formName="create-repair" />
        )}
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const RepairsCreateForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsCreateForm.tsx